module.exports = __webpack_public_path__ + "img/ben.658e5177.gif";